import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import {
  Box,
  Grid,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import moment from 'moment'
import config from '../../config'
const CustomTableCell = styled(TableCell)({
  borderRight: '1px solid rgba(224, 224, 224, 1)',
})
export const PostalVotingPage = (props) => {
  const { ag_id, coowner_id } = useParams()
  const [record, setRecord] = useState()
  useEffect(() => {
    const request = new Request(
      `${config.API_V1}/ags/${ag_id}/vpc/${coowner_id}`,
      {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    )
    fetch(request)
      .then(async (response) => await response.json())
      .then((r) => setRecord(r))
  }, [ag_id])

  const truncate = (str, n) => {
    return str?.length > n ? `${str.substr(0, n - 1)}...` : str
  }
  console.log(record)
  return record ? (
    <>
      {/*<div*/}
      {/*  style={{*/}
      {/*    // pageBreakBefore: 'always',*/}
      {/*    pageBreakAfter: 'always',*/}
      {/*  }}*/}
      {/*></div>*/}
      <Box
        style={{
          padding: '1rem',
          fontFamily: "'Source Sans Pro', sans-pro",
          fontSize: 12,
          display: 'block',
          breakInside: 'avoid',
        }}
      >
        <Box>
          <Typography
            variant="h5"
            style={{
              fontWeight: 'normal',
              color: 'black',
            }}
          >
            Formulaire de vote par correspondance
          </Typography>
        </Box>
        <Box
          style={{
            borderTop: '1px dotted black',
            borderBottom: '1px dotted black',
            marginBottom: '1rem',
            padding: '1rem 0',
          }}
        >
          <Box>
            <Typography variant="body2">
              <span
                style={{
                  color: 'black',
                  fontWeight: 'bold',
                }}
              >
                Copropriété
              </span>
              : #{record.copro_id} - {record.libelle}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2">
              {record.adresse} {record.codepostal} - {record.ville}
            </Typography>
          </Box>

          <Box>
            <Typography variant="body2">
              <span
                style={{
                  color: 'black',
                  fontWeight: 'bold',
                }}
              >
                Copropriétaire
              </span>
              : {record.coproprietaire}
            </Typography>
          </Box>
        </Box>

        <Typography variant="body2">
          Assemblée Générale du{' '}
          {moment(record.date).locale('fr').format('DD/MM/YYYY')} selon les
          moyens et supports mentionnés dans la convocation.
        </Typography>
        <Typography variant="body2">Ordre du jour :</Typography>
        <Table
          style={{
            border: '1px solid rgba(224, 224, 224, 1)',
          }}
        >
          <TableHead>
            <TableRow>
              <CustomTableCell>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  N°
                </Typography>
              </CustomTableCell>
              <CustomTableCell>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  RÉSOLUTION
                </Typography>
              </CustomTableCell>
              <CustomTableCell>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  POUR*
                </Typography>
              </CustomTableCell>
              <CustomTableCell>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  CONTRE*
                </Typography>
              </CustomTableCell>
              <CustomTableCell>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  ABSTENTION*
                </Typography>
              </CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {record.resolutions_numbers.map((number, idx) => (
              <TableRow key={`tablerow_${idx}_resolution`}>
                <CustomTableCell scope="row">
                  <Typography variant="body2">{number}</Typography>
                </CustomTableCell>
                <CustomTableCell align="left">
                  <Typography variant="body2">
                    {truncate(record.resolutions_libelles[idx], 50)}
                  </Typography>
                </CustomTableCell>
                <CustomTableCell align="left"></CustomTableCell>
                <CustomTableCell align="left"></CustomTableCell>
                <CustomTableCell align="left"></CustomTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Typography variant="body2" style={{ textAlign: 'right' }}>
          * cochez la case correspondante
        </Typography>
        <Box
          style={{
            border: 'solid grey',
            borderRight: '1px solid',
            padding: '1rem',
            paddingBottom: '4rem',
          }}
        >
          <Typography variant="body2">
            Signature du copropriétaire, de l’associé ou du mandataire commun :
          </Typography>
        </Box>
        <Typography variant="h6">
          Cas des résolutions faisant l’objet d'un second vote "passerelle" dans
          les conditions requises (25-1 et 26-1).et 26-1).
        </Typography>
        <Typography variant="body2">
          Si une résolution se vote à la majorité de l'article 25 ou 26 et
          n'obtient pas la majorité requise pour une adoption en première
          lecture, mais qu'elle obtient le seuil requis pour passer à un second
          vote passerelle, alors : Veuillez cocher d'une croix une case
          uniquement
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">je duplique mon vote</Typography>
          </li>
          <li>
            <Typography variant="body2">
              je mentionne mon vote en défaillant
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              je précise mes votes passerelles (veuillez remplir le tableau
              ci-dessous nommé "Second(s) vote(s) passerelle(s)", si celui-ci
              n'est pas rempli vos seconds votes passerelles seront considérés
              comme défaillants)
            </Typography>
          </li>
        </ul>
        <Table
          style={{
            border: '1px solid rgba(224, 224, 224, 1)',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell colSpan={5}>
                <Typography
                  variant="body2"
                  style={{ textAlign: 'center', fontWeight: 'bold' }}
                >
                  SECOND(S) VOTE(S) PASSERELLE(S)
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  N°
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  RÉSOLUTION
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  POUR*
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  CONTRE*
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  ABSTENTION*
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {record.revotable.map((revotable, idx) => (
              <TableRow>
                <CustomTableCell>
                  <Typography variant="body2">
                    {revotable.revotable_numero}
                  </Typography>
                </CustomTableCell>
                <CustomTableCell>
                  <Typography variant="body2">
                    {truncate(revotable.revotable_libelle, 50)}
                  </Typography>
                </CustomTableCell>
                <CustomTableCell>
                  <Typography variant="body2"></Typography>
                </CustomTableCell>
                <CustomTableCell>
                  <Typography variant="body2"></Typography>
                </CustomTableCell>
                <CustomTableCell>
                  <Typography variant="body2"></Typography>
                </CustomTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box
          style={{
            textAlign: 'right',
          }}
        >
          <Typography variant="body2">
            * cochez la case correspondante
          </Typography>
        </Box>
        <Box
          style={{
            border: 'solid grey',
            borderRight: '1px solid',
            padding: '1rem',
            paddingBottom: '4rem',
          }}
        >
          <Typography variant="body2">
            Signature du copropriétaire, de l’associé ou du mandataire commun :
          </Typography>
        </Box>
        <Box style={{ breakInside: 'avoid' }}>
          <Typography variant="h6">
            Rappel : Dispositions légales et réglementaires
          </Typography>
          <Typography variant="h6">La prise de décisions</Typography>
          <Typography variant="body2">
            Il s’agit du formulaire prévu par l’alinéa 2 de l’article 17-1 A de
            la loi n° 65-557 du 10 juillet 1965l’alinéa 2 de l’article 17-1 A de
            la loi n° 65-557 du 10 juillet 1965 qui précise que : « Les
            copropriétaires peuvent, par ailleurs, voter par correspondance
            avant la tenue de l'assemblée générale, au moyen d'un formulaire
            établi conformément à un modèle Vxé par arrêté. Si la résolution
            objet du vote par correspondance est amendée en cours d'assemblée
            générale, le votant par correspondance ayant voté favorablement est
            assimilé à un copropriétaire défaillant pour cette résolution. »
          </Typography>
          <Typography variant="body2">
            Ce formulaire est régi par les articles 9 alinéa 2, 9 bis, 14, 14-1
            et 17 alinéa 3 du décret n° 67-223 du 17 mars 1967 modiVé pris pour
            l'application de la loi n° 65-557 du 10 juillet 1965 Vxant le statut
            de la copropriété des immeubles bâtis, selon lesquels :
          </Typography>
          <Typography variant="h6">Alinéa 2 de l'article 9 :</Typography>
          <Typography variant="body2">
            « Le formulaire de vote par correspondance mentionné au deuxième
            alinéa de l’article 17-1 A est joint à la convocation. »
          </Typography>
          <Typography variant="h6">Article 9 bis :</Typography>
          <Typography variant="body2">
            « Lorsque le copropriétaire ou l’associé vote par correspondance, il
            transmet au syndic, par tout moyen permettant d’établir avec
            certitude la date de sa réception, le formulaire joint à la
            convocation trois jours francs au plus tard avant la réunion de
            l’assemblée générale. A défaut, il n’est pas tenu compte des votes
            exprimés dans ce formulaire. »
          </Typography>
          <Typography variant="h6">Article 14 :</Typography>
          <Typography variant="body2">
            « Il est tenu une feuille de présence, pouvant comporter plusieurs
            feuillets, qui indique les nom et domicile de chaque copropriétaire
            ou associé :
          </Typography>
          <ul>
            <li>
              <Typography variant="body2">
                Présent physiquement ou représenté ;
              </Typography>
            </li>
            <li>
              <Typography variant="body2">
                Participant à l’assemblée générale par visioconférence, par
                audioconférence ou par un autre moyen de communication
                électronique ;
              </Typography>
            </li>
            <li>
              <Typography variant="body2">
                Ayant voté par correspondance avec mention de la date de
                réception du formulaire par le syndic et, le cas échéant, ceux
                dont le vote, remis hors délai au syndic, a été écarté. »
              </Typography>
            </li>
          </ul>
          <Typography variant="h6">Article 14-1 :</Typography>
          <Typography variant="body2">
            « Le formulaire de vote par correspondance n’est pas pris en compte
            lorsque le copropriétaire, l’associé ou leur mandataire est présent
            à l’assemblée générale. »
          </Typography>
          <Typography variant="h6">Alinéa 3 de l’article 17 :</Typography>
          <Typography variant="body2">
            « Le procès-verbal comporte, sous l'intitulé de chaque question
            inscrite à l'ordre du jour, le résultat du vote. Il précise les noms
            et nombre de voix des copropriétaires ou associés qui se sont
            opposés à la décision, qui se sont abstenus, ou qui sont assimilés à
            un défaillant en application du deuxième alinéa de l’article 17-1 A
            de la loi du 10 juillet 1965. »
          </Typography>
        </Box>
      </Box>
    </>
  ) : null
}
